import { connect } from "react-redux";
import SiteConsumes from './siteConsumes';
import { bindActionCreators } from "redux";
import { getSiteConsumablesItems,updateSiteConsumesByOps } from "services/redux/installation/siteInspection/action";
const mapStateToProps = (state) => ({
  siteConsumables: state.siteInspectionReducer.siteConsumables,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteConsumablesItems,
      updateSiteConsumesByOps
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(SiteConsumes);